import { useEffect, useRef } from "react";
import { UpdateAccountErrorListKeys } from "../../login/components/UpdateAccountSection";
import ValidationAlertMessage from "../components/ValidationAlertMessage";
import translate from "../functions/translate";

interface FieldErrorProps {
    passwordRef?: HTMLElement | null
    header: string
    apiErrorListKey: UpdateAccountErrorListKeys | null
    setApiErrorMessageList: (value: React.SetStateAction<JSX.Element[]>) => void
    apiErrorMessageList: JSX.Element[]
}

export const useUpdateAccountFieldErrorMessageList = (props: FieldErrorProps) => {
    const { passwordRef, header, apiErrorListKey, setApiErrorMessageList, apiErrorMessageList } = props;
    const currentListKey = useRef<string | null>(null);

    useEffect(() => {
        const errorKeyToMessage: {
            [key in UpdateAccountErrorListKeys]: JSX.Element
        } = {
            checkPassword: <>
                <ValidationAlertMessage
                    description={translate("check_current_password")}
                    linkText={translate("password")}
                    fieldReference={passwordRef}
                    componentHeading={header}
                />
            </>,
            enterPassword: <>
                <ValidationAlertMessage
                    description={translate("enter_new_password_different_from_last_six")}
                    linkText={translate("password")}
                    fieldReference={passwordRef}
                    componentHeading={header}
                />
            </>,
            createPassword: <>
                <ValidationAlertMessage
                    description={translate("create_password_for_your_account")}
                    linkText={translate("password")}
                    componentHeading={header}
                />
            </>,
            enterEmail: <>
                <ValidationAlertMessage
                    description={translate('enter_email_or_select_do_not_have')}
                    linkText={translate("email_address")}
                    componentHeading={header}
                />
            </>,
            createUsername: <>
                <ValidationAlertMessage
                    description={translate("create_username_for_your_account")}
                    linkText={translate("username")}
                    componentHeading={header}
                />
            </>,
            alreadyUsed: <>
                <ValidationAlertMessage
                    description={translate("this_username_already_used")}
                    linkText={translate("username")}
                    componentHeading={header}
                />
            </>,
            question: <>
                <ValidationAlertMessage
                    description={translate("select_secret_question")}
                    linkText={translate("secret_question")}
                    componentHeading={header}
                />
            </>,
            answer: <>
                <ValidationAlertMessage
                    description={translate("enter_answer_to_your_secret_question")}
                    linkText={translate("secret_answer")}
                    componentHeading={header}
                />
            </>,
        }
        if (currentListKey.current === apiErrorListKey) {
            return;
        }
        if (apiErrorListKey && apiErrorListKey in errorKeyToMessage) {
            setApiErrorMessageList([errorKeyToMessage[apiErrorListKey], ...apiErrorMessageList]);
        } else {
            setApiErrorMessageList([]);
        }
        currentListKey.current = apiErrorListKey;
    }, [apiErrorListKey, apiErrorMessageList, header, passwordRef, setApiErrorMessageList]);
}